<template>
	<div id="app">
		<common-header></common-header>
		<keep-alive>
			<router-view/></router-view>
		</keep-alive>
		<common-footer></common-footer>
		<float-box></float-box>
	</div>
</template>

<script>
	import CommonHeader from "./components/header";
	import CommonFooter from "./components/footer";
	import FloatBox from "./components/floatbox";
	export default {
		name: 'App',
		data() {
			return {

			}
		},
		components: {
			'common-header': CommonHeader,
			'common-footer': CommonFooter,
			'float-box': FloatBox
		}
	}
</script>

<style>
	#app {
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}
</style>


// WEBPACK FOOTER //
// src/App.vue